import { apiClientPlatform } from "../config";

/**
 * getScheduledEvents
 * @function
 * @param {Object} [options]
 * @param {Object} [options.params] - Query params
 * @param {string} [options.params.sort]
 * @param {Object} [options.params.filter]
 * @param {(string[]|number[])} [options.params.filter.organization_id]
 * @param {(string[]|number[])} [options.params.filter.organization_plan_id]
 * @param {(string[]|number[])} [options.params.filter.teacher_id]
 * @param {string} [options.params.filter.calendly_start_time]
 * @param {string} [options.params.filter.calendly_end_time]
 * @param {string[]} [options.params.filter.status]
 * @param {(string|number)} [options.params.filter.owner_id]
 * @param {string} [options.params.include]
 * @param {number} [options.params.page]
 * @param {Object} [options.config] - Config Axios
 * @returns {Promise<any>}
 */
export const getScheduledEvents = async ({ params, config } = {}) => {
	const res = await apiClientPlatform.get("/support/scheduled-events", {
		params,
		...config,
	});
	return res.data;
};

/**
 * checkScheduledEventAnnotation
 * @function
 * @param {Object} [options]
 * @param {Object} [options.params] - Query params
 * @param {string} [options.params.organizationId]
 * @param {string} [options.params.scheduleEventId]
 * @param {Object} [options.config] - Config Axios
 * @returns {Promise<any>}
 */
export const checkScheduledEventAnnotation = async ({ params, config } = {}) => {
	const { organizationId, scheduleEventId, ...otherParams } = params;
	const res = await apiClientPlatform.get(
		`/support/organizations/${organizationId}/scheduled-events/${scheduleEventId}/annotations`,
		{
			params: otherParams,
			...config,
		}
	);
	return res.data;
};
